import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { select, Store } from '@ngrx/store';

import { map, Observable, takeWhile, tap, timer } from 'rxjs';

import { MainTabBasePathEnum } from '../../enums/main-tabs';
import { StripePaymentStatusEnum } from '../../enums/monetization';
import { ProfileSearchEnum } from '../../enums/profile-search';
import * as fromMonetizationActions from '../../store/actions/monetization.actions';
import * as fromUserActions from '../../store/actions/user.actions';
import * as fromMonetizationSelectors from '../../store/selectors/monetization.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-payment-redirect',
  standalone: false,
  templateUrl: './redirect.page.html'
})
export class RedirectPageComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private store = inject(Store);

  timeRemaining$: Observable<number> | null = null;
  isSuccess = false;
  isRedirected = false;
  redirectBackUrl = '/';

  defaultBackHref: string | undefined;

  constructor() {
    this.defaultBackHref = this.activatedRoute.snapshot.data['defaultBackHref'];

    this.isSuccess = this.activatedRoute.snapshot.paramMap.get('status') === StripePaymentStatusEnum.Success;
    this.store.pipe(select(fromMonetizationSelectors.selectWebRedirectBackUrl)).subscribe((redirectBackUrl) => {
      this.redirectBackUrl = redirectBackUrl;
    });
    if (this.isSuccess) {
      this.store.dispatch(
        fromMonetizationActions.logUserPurchase({
          payload: {
            resumePurchaseFlow: false,
            searchType:
              this.defaultBackHref === MainTabBasePathEnum.PropertySearch
                ? ProfileSearchEnum.PropertySearchWalkingFarm
                : ProfileSearchEnum.WalkingFarm
          }
        })
      );
    }
  }

  ngOnInit() {
    this.isRedirected = false;
    this.timeRemaining$ = timer(0, 1000).pipe(
      map((n) => (10 - n) * 1000),
      tap(async (n) => {
        if (n == 0) {
          await this.return();
        }
      }),
      takeWhile((n) => n >= 0)
    );
  }

  async return() {
    if (!this.isRedirected) {
      this.isRedirected = true;
      this.store.dispatch(fromUserActions.reloadMobileUser());
      await this.router.navigate([this.redirectBackUrl]);
      this.store.dispatch(
        fromMonetizationActions.resumePurchasePhoneAndEmailPreview({
          payload: {
            searchType:
              this.defaultBackHref === MainTabBasePathEnum.PropertySearch
                ? ProfileSearchEnum.PropertySearchWalkingFarm
                : ProfileSearchEnum.WalkingFarm
          }
        })
      );
    }
  }
}
